/**
 * Firebase Analytics — lazy-loaded after page load to avoid blocking FCP/LCP.
 *
 * The firebase SDK (~50KB+) is dynamically imported only when first used,
 * keeping it out of the main bundle. Events queued before init are flushed
 * once analytics is ready.
 */

const firebaseConfig = {
  apiKey: "AIzaSyD4darCk0cWO1qzXZj332C1IxT0c4I-VNg",
  authDomain: "letspointie-ca.firebaseapp.com",
  projectId: "letspointie-ca",
  storageBucket: "letspointie-ca.firebasestorage.app",
  messagingSenderId: "953332926103",
  appId: "1:953332926103:web:30eefc76e910e3e71a8bd2",
  measurementId: "G-7X2KTVHSRG",
};

let analyticsInstance = null;
let initPromise = null;
const queue = [];

const initFirebase = () => {
  if (initPromise) return initPromise;

  initPromise = (async () => {
    const [{ initializeApp }, { initializeAnalytics, logEvent }] = await Promise.all([
      import("firebase/app"),
      import("firebase/analytics"),
    ]);

    const app = initializeApp(firebaseConfig);
    analyticsInstance = {
      analytics: initializeAnalytics(app, { config: { send_page_view: true } }),
      logEvent,
    };

    // Flush queued events
    while (queue.length > 0) {
      const { eventName, params } = queue.shift();
      try {
        analyticsInstance.logEvent(analyticsInstance.analytics, eventName, params);
      } catch (e) {
        // ignore
      }
    }
    return analyticsInstance;
  })();

  return initPromise;
};

// Trigger init after first paint / when browser is idle
if (typeof window !== "undefined") {
  const trigger = () => initFirebase();
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(trigger, { timeout: 3000 });
  } else {
    setTimeout(trigger, 1500);
  }
}

const sendEvent = (eventName, params = {}) => {
  if (analyticsInstance) {
    try {
      analyticsInstance.logEvent(analyticsInstance.analytics, eventName, params);
    } catch (e) {
      // ignore
    }
  } else {
    queue.push({ eventName, params });
    initFirebase();
  }
};

export const trackPageView = (pageName) => {
  sendEvent("page_view", { page_title: pageName });
};

export const trackEvent = (eventName, params = {}) => {
  sendEvent(eventName, params);
};

export const trackError = (error, context = "") => {
  sendEvent("exception", {
    description: `${context}: ${error.message || error}`.substring(0, 500),
    fatal: false,
  });
};
